import { useEffect, useState } from "react";
import Button from "../../../Custom/Button/Button";
import backImg from "../../../../picture/Back.png";
import DokumentaZaposlenogVazeca from "./DokumentaZaposlenogVazeca";
import DokumentaZaposlenogArhivirana from "./DokumentaZaposlenogArhivirana";

const vazecaDokumentaMock = [
  {
    id: "1",
    naziv: "Ugovor o radu",
    text: "", // ""/"green"/"red"/"orange"
    word: "green",
    pdf: "green",
    image: "orange",
    scan: ""
  },
  {
    id: "2",
    naziv: "MA obrazac",
    text: "green",
    word: "orange",
    pdf: "",
    image: "",
    scan: ""
  },
  {
    id: "3",
    naziv: "Uput za lekarski",
    text: "green",
    word: "orange",
    pdf: "",
    image: "",
    scan: ""
  },
  {
    id: "4",
    naziv: "Lekarski izvestaj",
    text: "green",
    word: "orange",
    pdf: "",
    image: "",
    scan: ""
  },
  {
    id: "5",
    naziv: "Zaduzenje LZO",
    text: "green",
    word: "orange",
    pdf: "",
    image: "red",
    scan: "red"
  },
  {
    id: "6",
    naziv: "Test BZR",
    text: "green",
    word: "orange",
    pdf: "",
    image: "red",
    scan: ""
  },
  {
    id: "7",
    naziv: "Zapisnik BZR",
    text: "green",
    word: "orange",
    pdf: "red",
    image: "",
    scan: ""
  }
];

const arhiviranaDokumentaMock = [
  {
    id: "11",
    naziv: "Ugovor o radu Staro",
    text: "", // ""/"green"/"red"/"orange"
    word: "green",
    pdf: "green",
    image: "orange",
    scan: ""
  },
  {
    id: "12",
    naziv: "MA obrazac Staro",
    text: "green",
    word: "orange",
    pdf: "",
    image: "",
    scan: ""
  },
  {
    id: "13",
    naziv: "Uput za lekarski Staro",
    text: "green",
    word: "orange",
    pdf: "",
    image: "",
    scan: ""
  },
  {
    id: "14",
    naziv: "Lekarski izvestaj Staro",
    text: "green",
    word: "orange",
    pdf: "",
    image: "",
    scan: ""
  }
];

function PreviewZaposlen({ zaposlenId, setZaposlenId }) {
  const [vazecaDokumenta, setVazecaDokumenta] = useState(vazecaDokumentaMock);
  const [arhiviranaDokumenta, setArhiviranaDokumenta] = useState(
    arhiviranaDokumentaMock
  );

  useEffect(() => {
    setVazecaDokumenta(vazecaDokumentaMock);
  }, [vazecaDokumentaMock]);

  useEffect(() => {
    setArhiviranaDokumenta(arhiviranaDokumentaMock);
  }, [arhiviranaDokumentaMock]);

  const moveToArhivirani = (dokument) => {
    setArhiviranaDokumenta((prev) => [...prev, dokument]);
    setVazecaDokumenta((prev) => prev.filter((dok) => dok.id !== dokument.id));
  };

  const moveToVazeci = (dokument) => {
    setVazecaDokumenta((prev) => [...prev, dokument]);
    setArhiviranaDokumenta((prev) =>
      prev.filter((dok) => dok.id !== dokument.id)
    );
  };

  const handleBack = () => {
    setZaposlenId("");
  };

  return (
    <div>
      <div onClick={handleBack} style={{ width: "100px", height: "50px" }}>
        <Button activation={true}>
          <img src={backImg} />
        </Button>
      </div>

      <div
        style={{
          overflowY: "auto",
          height: "420px",
          marginTop: "20px"
        }}
      >
        <DokumentaZaposlenogVazeca
          dokumenta={vazecaDokumenta}
          moveToArhivirani={moveToArhivirani}
        />

        <div style={{ marginTop: "20px" }}>
          <DokumentaZaposlenogArhivirana
            dokumenta={arhiviranaDokumenta}
            setDokumenta={setArhiviranaDokumenta}
            moveToVazeci={moveToVazeci}
          />
        </div>
      </div>
    </div>
  );
}

export default PreviewZaposlen;
